















































import { defineComponent, ref, computed } from '@vue/composition-api'
import { useFormRef } from '@/composable/common/useFormRef'
import { QuestionnairePageEntity } from '../../../../api/@types'

type Props = {
  pages: QuestionnairePageEntity[]
  pageId: number
  questionId: number
  initChoices: number[]
  initDestinationPageId: number | null
}

export default defineComponent({
  name: 'ConditionForm',
  props: {
    pages: {
      type: Array,
      required: true,
    },
    pageId: {
      type: Number,
      required: true,
    },
    questionId: {
      type: Number,
      required: true,
    },
    initChoices: {
      type: Array,
      default: () => [],
    },
    initDestinationPageId: {
      type: Number,
      default: null,
    },
  },
  setup(props: Props, context) {
    const input = ref({
      choices: props.initChoices,
      destinationPageId: props.initDestinationPageId,
    })
    const { form, validate, reset } = useFormRef()

    const destinationPages = computed(() =>
      props.pages.filter(page => page.id !== props.pageId),
    )

    const choices = computed(
      () =>
        (props.pages
          .find(page => page.id === props.pageId)
          ?.questions.find(question => question.id === props.questionId) as any)
          ?.choices,
    )

    const choiceRules = [
      (v: number[]) => !!v.length || '選択肢の入力は必須です。',
    ]
    const pageRules = [(v: number) => !!v || '遷移先の入力は必須です。']

    const save = async () => {
      if (!validate()) {
        return
      }

      context.emit('submit', {
        body: {
          ...input.value,
          type: 'include',
          operation: 'and',
        },
        done: () => reset(),
      })
    }

    return {
      input,
      form,
      destinationPages,
      choices,
      choiceRules,
      pageRules,
      save,
    }
  },
})
